import {
  useGetCountriesQuery,
  useGetLoanTypesQuery,
  useGetLoanStatusesQuery,
  useGetPropertyTypesQuery,
  useGetPropertyUsesQuery,
} from "@/modules/shared/store/services/endpoints";

/**
 * useLoanApplicationParameters — triggers only the parameter queries
 * required by the borrower loan-application wizard.
 *
 * Unlike `useGlobalParameters` (which fires all 21 queries), this hook
 * is scoped to the five datasets the wizard actually consumes:
 *   countries, loanTypes, loanStatuses, propertyTypes, propertyUses.
 *
 * States are fetched on-demand by `StateSelect` via `useGetStatesQuery`.
 *
 * @returns {{ isLoading: boolean, isReady: boolean, error: unknown }}
 */
export default function useLoanApplicationParameters() {
  const queries = [
    useGetCountriesQuery(),
    useGetLoanTypesQuery(),
    useGetLoanStatusesQuery(),
    useGetPropertyTypesQuery(),
    useGetPropertyUsesQuery(),
  ];

  const isLoading = queries.some(q => q.isLoading);
  const error = queries.find(q => q.error)?.error ?? null;
  const isReady = queries.every(q => q.isSuccess);

  return { isLoading, isReady, error };
}

